/* eslint-disable react/jsx-handler-names */
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

import { getPagePath, trans } from '@spotahome/soyuz/client';
import Metrics from '@spotahome/soyuz-metrics';
import { Button } from '@spotahome/ui-library';

import { extractItem, setItem } from '../../utils/soyuzLocalStorage';

import OtherCityModal from '../OtherCityModal';
import withModalHandle from '../withModalHandle';

import CitySelect from './CitySelect';
import './CitySelector.scss';

const CITY_KEY = 'sah-search-city';

const SEARCH_BUTTON_TEXT =
  'landingpage.city_selector.button.explore_experimental';

const OTHER_CITY_ID = 'other';

const saveSearchState = state => {
  if (state.city) {
    setItem(CITY_KEY, state.city);
  }
};

const sendEventData = state => {
  const { city } = state;
  const eventData = [city];

  Metrics.ga.sendEventWithClientId(
    'dwh-city-date-homepage',
    eventData.join(';')
  );
};

const getMinStay = (cities, selectedCity) => {
  const currentCity = cities.find(city => city.id === selectedCity);
  if (currentCity) {
    return currentCity.minimumStaying;
  }
  return undefined;
};

const getSearchState = state => {
  return {
    city: extractItem(CITY_KEY) || state.city
  };
};

class CitySelector extends Component {
  state = {
    city: undefined
  };

  cities = this.getCities();
  shakingTimeout = undefined;

  componentDidMount() {
    // NOTE: Avoiding server side render warning "prop did not match"
    // due that server cant access local storage
    this.updateState();
  }

  activateShaking = () => {
    if (this.shakingTimeout) {
      clearTimeout(this.shakingTimeout);
      this.shakingTimeout = undefined;
    }
    this.setState({ shaking: true });
    this.shakingTimeout = setTimeout(
      () => this.setState({ shaking: false }),
      1000
    );
  };

  handleClickExploreButton = e => {
    e.preventDefault();
    const { city } = this.state;
    if (!city) {
      this.activateShaking();
      return;
    }
    sendEventData(this.state);
    saveSearchState(this.state);

    window.location.href = this.getSearchUrl();
  };

  handleCityChange = e => {
    const selectedCity = e.target.value;

    Metrics.ga.sendEvent('Home', 'selected-city', selectedCity);

    if (selectedCity === OTHER_CITY_ID) {
      this.props.handleModalOpen();
    } else {
      this.setState({
        city: selectedCity,
        minStay: getMinStay(this.props.cities, selectedCity)
      });
    }
  };

  getCities() {
    const { cities } = this.props;

    if (!cities) {
      return {};
    }

    return [...cities, { id: OTHER_CITY_ID }].reduce(
      (acc, cur) => ({
        ...acc,
        [trans(`landingpage.label.${cur.id}`)]: cur.id
      }),
      {}
    );
  }

  setDate = newDate => {
    this.setState(newDate);
  };

  getSearchUrl = () => {
    const { city } = this.state;

    if (!city || city === OTHER_CITY_ID) {
      return '';
    }

    return getPagePath('realestate.search', {
      params: { city: city.toLowerCase() }
    });
  };

  updateState() {
    const { cities } = this.props;

    this.setState(prevState => {
      const newState = getSearchState(prevState);
      if (!newState.city) {
        return {};
      }
      return {
        ...newState,
        minStay: getMinStay(cities, newState.city)
      };
    });
  }

  render() {
    const { city, shaking } = this.state;

    const { handleModalClose, isModalOpen, className } = this.props;

    const searchUrl = this.getSearchUrl();

    return (
      <div className={classNames('city-selector', className)}>
        <CitySelect
          currentCity={city}
          onCityChange={this.handleCityChange}
          cities={this.cities}
          className={classNames('city-selector__city', 'ga-home-select-city', {
            'city-selector__city--shaking': shaking
          })}
        />
        <Button
          href={searchUrl}
          className="city-selector__cta--small city-selector__cta ga-home-explore"
          onClick={this.handleClickExploreButton}
        >
          {trans(SEARCH_BUTTON_TEXT)}
        </Button>
        <OtherCityModal
          isOpen={isModalOpen}
          handleModalClose={handleModalClose}
        />
      </div>
    );
  }
}
CitySelector.propTypes = {
  handleModalOpen: PropTypes.func.isRequired,
  handleModalClose: PropTypes.func.isRequired,
  isModalOpen: PropTypes.bool.isRequired,
  className: PropTypes.string,
  cities: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.string,
      minimumStaying: PropTypes.number
    })
  ).isRequired
};
CitySelector.defaultProps = {
  className: ''
};

export default withModalHandle()(CitySelector);
